import styled from 'styled-components'

export const TableOuter = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 2rem;
`
export const TableRow = styled.div`
  display: flex;
  & + & {
    border-top: 0.175rem solid #9c91bd;
  }
`
export const TableCell = styled.div`
  padding: 1rem;
  font-size: 0.9rem;
  line-height: 1.5;
  flex: 1 1 0;
  display: flex;
  align-items: center;
`
export const TableHeadCell = styled(TableCell)`
  font-size: 1.25rem;
  font-weight: 700;
  color: #9c91bd;
  flex: 0 0 10rem;
  align-items: flex-start;
`